import { render, staticRenderFns } from "./AppJobRecordItem.vue?vue&type=template&id=395c60c0&scoped=true&"
import script from "./AppJobRecordItem.vue?vue&type=script&lang=js&"
export * from "./AppJobRecordItem.vue?vue&type=script&lang=js&"
import style0 from "./AppJobRecordItem.vue?vue&type=style&index=0&id=395c60c0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395c60c0",
  null
  
)

export default component.exports